import React, { useState } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Services
import companyServices from 'services/company'

const searchAccounts = (search) => {
	return new Promise((resolve, reject) => {
		companyServices.listAccounts({ search_value: search }).then((payload) => {
			let results = payload.accounts.map((account) => {
				return {...account, value: account.company_account_code, label: (account.name + ' ' + account.surname)};
			})
			resolve(results);
		}).catch(() => {
			reject(false);
		})
	})
}

const searchGroups = (search) => {
	return new Promise((resolve, reject) => {
		companyServices.listGroups({ search_value: search }).then((payload) => {
			let results = payload.groups.map((group) => {
				return {...group, value: group.store_code, label: group.name};
			})
			resolve(results);
		}).catch(() => {
			reject(false);
		})
	})
}

const LinkAccountToGroupModal = (props) => {
	const groupID = props.groupID;
	const accountID = props.accountID;
	const close = props.close;

	const [submitting, setSubmitting] = useState(false);

	const submit = (formData) => {
		setSubmitting(true);

		companyServices.matchAccountAndGroup(
			(groupID ? groupID : formData.store_code),
			(accountID ? accountID : formData.company_account_code),
			formData.default ? true : false
		).then(() => {
			props.onSuccess();

			close();
		}).catch(() => {}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{!accountID ? 'Kullanıcı Ekle' : 'Grup Ekle'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content">
				{!accountID ?
					<FormInput
						disabled={submitting}
						type="select"
						z="4"
						label="Kullanıcı"
						placeholder="Grubu Tanımlamak İstediğiniz Kullanıcıyı Seçin"
						async
						defaultOptions
						loadOptions={searchAccounts}
						validation={{
							required: 'Bir kullanıcı hesabı seçmelisiniz.'
						}}
						name="company_account_code" />		
					:
					<FormInput
						disabled={submitting}
						type="select"
						z="4"
						label="Grup"
						placeholder="Kullanıcıya Tanımlamak İstediğiniz Grubu Seçin"
						async
						defaultOptions
						loadOptions={searchGroups}
						validation={{
							required: 'Bir grup seçmelisiniz.'
						}}
						name="store_code" />		
				}
				<FormInput
					disabled={submitting}
					type="checkbox"
					label="Varsayılan grup olarak ekle"
					name="default"
					value="1" />
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting}
					type="submit">
					Ekle
				</Btn>
			</div>
		</InputForm>
	)
}

LinkAccountToGroupModal.defaultProps = {
	className: '',
	containerClass: 'modal-link-account-to-group mobile-full',
	name: 'link-account-to-group',
	title: false,
	content: false,
	source: false,
	groupID: false,
	accountID: false,
}

export default LinkAccountToGroupModal